import type { CreateIntentRequest } from '@xpanse/ui';

import { useMutation } from '@tanstack/react-query';

import { IntentService } from 'src/utils/services';

export const createUserIntent = async (data: CreateIntentRequest) => {
  const response = await IntentService.createIntent(data);
  return response;
};

export function useCreateIntent() {
  const { mutate: createIntent, isPending } = useMutation({
    mutationFn: createUserIntent,
  });

  return {
    createIntent,
    isIntentPending: isPending,
  };
}
